// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container{display:flex;flex-direction:column}.container .appbar{position:relative;border:none;height:auto;box-shadow:1px .267vw .4vw #eee}.container .appbar:after{content:\"\";position:absolute;background:#eee;bottom:0;left:0;width:100%;height:.267vw;transform:scaleY(.5);transform-origin:0 bottom}.container .appbar .van-nav-bar .van-icon,.container .appbar .van-nav-bar__title{color:inherit}.container .content{flex:1;overflow:auto}", ""]);
// Exports
module.exports = exports;
